import Vue from "vue";

export const AssinaturaMixin = {
    name: "assinaturaMixin",
    methods: {
      validaAssinatura(sendFunction, params = null) {
        this.initializeFormConfirmPassword();
        this.showDialogConfirmPassword = !this.showDialogConfirmPassword;
        this.send.function = sendFunction;
        this.send.params = params;

      },
  
      initializeFormConfirmPassword() {
        this.formConfirmPassword = {
          password: "",
          justificativa: "",
        };
      },

      verificaPermissaoFuncionalidade: async function (
          idfuncionalidade,
          redirectNoPermission = false,
      ) {
        const arrayFuncionalidadesAcessiveis = await Vue.prototype
            .$funcionalidadesAcessiveis;

        /*const arrayIDFuncionalidades = arrayFuncionalidadesAcessiveis.map(
          (funcionalidade) => funcionalidade.id,
        );*/
        let arrayIDFuncionalidades = [];
        if (typeof arrayFuncionalidadesAcessiveis !== "undefined") {
          arrayIDFuncionalidades = arrayFuncionalidadesAcessiveis.map(function (item) {
            return (item.id);
          });
        }


        const havePermission = arrayIDFuncionalidades.includes(idfuncionalidade);
        console.log(havePermission)
        if (!havePermission && redirectNoPermission) {
          this.$router.push("/no-permission");
        }

        return havePermission;
      },
    },
  };